




































import Vue from 'vue';
import { Type, NoExpression, Expression, Entity, EntityTranscoder } from 'expangine-runtime';
import { Registry } from '../runtime/Registry';


export default Vue.extend({
  props: {
    property: {
      type: String,
      required: true,
    },
    transcoder: {
      type: Object as () => EntityTranscoder,
      required: true,
    },
    registry: {
      type: Object as () => Registry,
      required: true,
    },
    entity: {
      type: Object as () => Entity,
    },
  },
  computed: {
    decodeContext(): Type {
      return this.entity.getDecodeContext(this.property, this.transcoder.encodedType);
    },
    decodeExpected(): Type {
      return this.entity.getDecodeExpected(this.property);
    },
    encodeContext(): Type {
      return this.entity.getEncodeContext(this.property);
    },
    invalidEncode(): boolean {
      const { encode } = this.transcoder;

      return encode === NoExpression.instance || !this.isValid(encode, this.encodeContext);
    },
    invalidDecode(): boolean {
      const { decode } = this.transcoder;

      return decode === NoExpression.instance || !this.isValid(decode, this.decodeContext, this.decodeExpected);
    },
    valid(): boolean {
      return !this.invalidEncode && !this.invalidDecode;
    },
  },
  watch: {
    transcoder(transcoder: EntityTranscoder) {
      this.updateEncoded(transcoder.encode, true);
    },
  },
  methods: {
    updateEncoded(encode: Expression, skipSave: boolean = false) {
      const encodedType = encode.getType(this.registry.defs, this.encodeContext);

      this.transcoder.encode = encode;

      if (encodedType) {
        this.transcoder.encodedType = encodedType;
      }

      if (!skipSave) {
        this.saved();
      }
    },
    isValid(expr: Expression, context: Type, expected?: Type): boolean {
      if (expr.validations(this.registry.defs, context).length > 0) {
        return false;
      }
      if (expected) {
        const exprType = expr.getType(this.registry.defs, context);
        
        return !!(exprType && expected.acceptsType(exprType));
      }
      return true;
    },
    saved() {
      if (this.valid) {
        Vue.set(this.entity.transcoders, this.property, this.transcoder);

        this.$emit('saved', this.property);
      }
    },
  },
});
